// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import React, { useState } from 'react'
import Modal from '@uswitch/ev-components/lib/components/elements/modal'
import { useComponentTracking } from '../../utils/component-events'
import CalculatorForm from './calculator-form'

const Calculator = ({
  calculatorSchema,
  calculatorState,
  submit,
  modalContent,
  variant,
  trackInteraction = () => {},
  resultsAvailable = true,
}) => {
  const [modalOpen, setModalOpen] = useState(false)
  const toggleModal = () => setModalOpen(!modalOpen)
  const handleKeypress = ({ key }) => key === 'Enter' && toggleModal()
  const trackComponent = useComponentTracking()

  const mapTrackingData = (data) => {
    return Object.entries(data).reduce((o, [key, value]) => {
      return { [key]: Array.isArray(value) ? value.join(',') : value, ...o }
    }, {})
  }

  const calculatorSubmit = (data) => {
    const updateTerm = (data) => data.term && (data.term = data.term * 12)
    updateTerm(data)
    const calculatorData = {
      type: 'calculator',
      inputs: { ...data },
    }

    trackComponent('Product Table Event', 'filterApplied', mapTrackingData(data))
    submit({ ...calculatorState, ...calculatorData })
  }
  return (
    <React.Fragment>
      <div
        sx={{
          variant: `elements.calculator.${variant}.container`,
        }}
      >
        {calculatorSchema.title && (
          <div
            sx={{
              variant: `elements.calculator.${variant}.title`,
            }}
          >
            {calculatorSchema.title}
          </div>
        )}
        <div sx={{ variant: `elements.calculator.${variant}.wrapper` }}>
          {calculatorSchema.label && (
            <div sx={{ variant: `elements.calculator.${variant}.label` }}>
              {calculatorSchema.label}
            </div>
          )}
          <CalculatorForm
            schema={calculatorSchema}
            submit={calculatorSubmit}
            variant={variant}
            trackInteraction={trackInteraction}
          />
          {modalContent && (
            <div
              sx={{ variant: 'elements.calculator.modal.label' }}
              onClick={toggleModal}
              onKeyPress={handleKeypress}
              role='link'
              tabIndex={0}
            >
              How it works
              <Modal close={toggleModal} isOpen={modalOpen} type='calculator'>
                <div
                  sx={{
                    flexDirection: ['column', 'row'],
                    variant: 'elements.calculator.modal.content',
                  }}
                >
                  {modalContent}
                </div>
              </Modal>
            </div>
          )}
          <If condition={!resultsAvailable}>
            <div sx={{ variant: 'elements.calculator.result.error' }}>
              There are no results matching your search, please try again.
            </div>
          </If>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Calculator
